// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"c73be366","1667":"84fba2c2"}[chunkId] + ".chunk.css";
};